/**
 * m3u8マスターマニフェストから画像ストリーム（サムネイル）のURIを抽出
 * #EXT-X-IMAGE-STREAM-INF タグのURI属性を取得
 * @see https://developers.play.jp/entry/2023/05/26/171431#EXT-X-IMAGE-STREAM-INF
 */
export const parseM3u8ToExtractThumbnailManifestFileName = (
  data: string
): string | null => {
  // #EXT-X-IMAGE-STREAM-INF の行を探してURIを抽出
  const match = /#EXT-X-IMAGE-STREAM-INF:[^]*?URI="([^"]+)"/.exec(data);
  const uri = match?.[1] ?? null;
  if (uri === null) return null;

  // クエリパラメータを除去
  return uri.split("?")[0] ?? null;
};

const IMAGE_EXTENSIONS = [".jpg", ".jpeg", ".png", ".webp"] as const;

const isImageFile = (line: string): boolean => {
  return IMAGE_EXTENSIONS.some(
    (ext) => line.endsWith(ext) || line.includes(`${ext}?`)
  );
};

/**
 * m3u8プレイリストをパースして最後のサムネイルファイル名を取得
 */
export const parseM3u8ForLastThumbnail = (
  m3u8Content: string
): string | null => {
  const lines = m3u8Content.trim().split("\n");

  // 最後から逆順に探索して、画像ファイルの行を見つける
  for (let i = lines.length - 1; i >= 0; i--) {
    const line = lines[i];
    if (!line) continue;
    const trimmedLine = line.trim();
    if (isImageFile(trimmedLine)) {
      // クエリパラメータを除いたファイル名を返す
      return trimmedLine.split("?")[0] ?? null;
    }
  }

  return null;
};
